import React, { useState } from 'react';
import { Modal } from 'antd';
import { UNCHANGED_STATE } from './constants';
import { useRoomListStepMutation } from '../../../../api/changeRoomListSteps';
import SelectStep from './SelectStep';

const ChangeStep = ({
  visible,
  onCancel,
  onSettled,
  addressIds,
  afterClose,
}) => {
  const [value, setValue] = useState();

  const { isLoading, mutate } = useRoomListStepMutation({
    onSuccess: onSettled,
  });

  const handleOk = () => {
    if (value == null) {
      onSettled(UNCHANGED_STATE);
      return;
    }

    mutate({ addressIds, stepId: value });
  };

  const _afterClose = () => {
    setValue(undefined);

    if (typeof afterClose === 'function') {
      afterClose();
    }
  };

  const handleChange = (value) => {
    setValue(value);
  };

  return (
    <Modal
      title="Изменение этапа"
      visible={visible}
      maskClosable={false}
      onCancel={onCancel}
      afterClose={_afterClose}
      onOk={handleOk}
      confirmLoading={isLoading}
      centered
    >
      <SelectStep value={value} onChange={handleChange} />
    </Modal>
  );
};

export default ChangeStep;
